// Module
var code = "<span class=\"tc-link\">\n  <router-link v-if=\"routeName\" role=\"link\" :to=\"{ name: routeName }\" :aria-label=\"ariaLabel\">\n    <slot></slot>\n  </router-link>\n  <a v-if=\"href\" :title=\"href\" role=\"link\" :href=\"href\" rel=\"noopener noreferrer\" target=\"_blank\" :aria-label=\"ariaLabel\">\n    <slot></slot>\n  </a>\n</span>\n";
// Exports
export default code;